import styles from './SearchContainer.module.css'
import { JSX, useEffect, useState } from "react"
import { Col, Collapse, Container, Form, Row } from "react-bootstrap"
import DefaultButton from '../../../../../../components/buttons/default-button/DefaultButton'
import FilterButton from '../../../../../../components/buttons/filter-button/FilterButton'
import { useSetSearchUrlParams } from '../../../../../../hooks/usePagination'
import { SetURLSearchParams } from 'react-router-dom'
import { VpnLoginSearchParams } from '../VpnLogs'
import { VPN_LOGIN_STATUS } from '../../log/Log'

interface SearchContainerProps {
    searchParameters: VpnLoginSearchParams
    setSearchParams: SetURLSearchParams
    pagination: JSX.Element
    removeDefaultLoginAtDateFilter: () => void
}

export default function SearchContainer(props: SearchContainerProps) {
    const [showSearchContainer, setShowSearchContainer] = useState(true)
    const { searchParameters, setSearchParams, removeDefaultLoginAtDateFilter, pagination } = props

    const [ resetDefaultDateFilter, setResetDefaultDateFilter ] = useState(false)
    const [username, setUsername] = useState(searchParameters.user.username ?? '')
    const [ipAddress, setIpAddress] = useState(searchParameters.ipAddress ?? '')
    const [login, setLogin] = useState(searchParameters.loginAt ?? '')
    const [logout, setLogout] = useState(searchParameters.logoutAt ?? '')
    const [status, setStatus] = useState(searchParameters.status ?? '')
    const setSearchUrlParams = useSetSearchUrlParams(setSearchParams)

    useEffect(() => {
        setUsername(searchParameters.user.username ?? '')
        setIpAddress(searchParameters.ipAddress ?? '')
        setLogin(searchParameters.loginAt ?? '')
        setLogout(searchParameters.logoutAt ?? '')
        setStatus(searchParameters.status ?? '')
    }, [searchParameters])

    return (
        <Container className={styles.searchContainer}>
            <Row className="g-0 position-relative">
                <Col className="col-4 d-flex align-items-center">
                    <div>
                        <FilterButton title="Szűrő" onClick={() => setShowSearchContainer(prev => !prev)} isOpen={showSearchContainer} />
                    </div>
                </Col>

                <div className="col-8 d-flex relative align-items-center flex-row-reverse">
                    {pagination}
                </div>
            </Row>

            <Collapse in={showSearchContainer}>
                <div>
                    <Row className={styles.inputFieldsContainer}>
                        <Row className="g-0">
                            <Col className={`d-flex justify-content-center gap-4 align-items-center`}>
                                <div>
                                    <label className={styles.label} htmlFor="username">Felhasználónév</label>
                                    <input
                                        type="text"
                                        id='username'
                                        placeholder='Felhasználónév'
                                        value={username}
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const username = e.target.value
                                            setUsername(username)

                                            if (username.length === 0) {
                                                searchParameters.user.username = null
                                                return
                                            }

                                            searchParameters.user.username = username
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.label} htmlFor="ip">IP</label>
                                    <input
                                        type="text"
                                        id='ip'
                                        placeholder='IP'
                                        value={ipAddress}
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const ipAddress = e.target.value
                                            setIpAddress(ipAddress)

                                            if (ipAddress.length === 0) {
                                                searchParameters.ipAddress = null
                                                return
                                            }

                                            searchParameters.ipAddress = ipAddress
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.label} htmlFor="login">Belépés</label>
                                    <input
                                        type="date"
                                        id='login'
                                        placeholder='Belépés'
                                        value={login}
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const value = e.target.value

                                            setLogin(value)

                                            searchParameters.loginAt = value

                                            if(!resetDefaultDateFilter && value.length === 0) {
                                                setResetDefaultDateFilter(true)
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.label} htmlFor="logout">Kilépés</label>
                                    <input
                                        type="date"
                                        id='logout'
                                        placeholder='Kilépés'
                                        value={logout}
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const logout = e.target.value
                                            setLogout(logout)

                                            if (logout.length === 0) {
                                                searchParameters.logoutAt = null
                                                return
                                            }

                                            searchParameters.logoutAt = logout
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.label} htmlFor="status">Státusz</label>
                                    <Form.Select 
                                        id="status"
                                        value={status}
                                        onChange={(e) => {
                                            const value = e.target.value.toUpperCase()

                                            setStatus(value)
                                            searchParameters.status = value as (VPN_LOGIN_STATUS | null)
                                        }}
                                        className={styles.searchInput}
                                        >
                                        <option value=''>Minden</option>
                                        <option value='ACTIVE'>Aktív</option>
                                        <option value='INACTIVE'>Inaktív</option>
                                    </Form.Select>
                                </div>

                            </Col>
                        </Row>

                        <Row className="g-0">
                            <Col className={`d-flex justify-content-center align-items-end position-relative`}>
                                <DefaultButton title="Keresés" onClick={e => {
                                    e.preventDefault()

                                    if(resetDefaultDateFilter) {
                                        removeDefaultLoginAtDateFilter()
                                    }

                                    setSearchUrlParams({
                                        ...searchParameters,
                                        user: searchParameters.user.username
                                    })
                                }} />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </Collapse>
        </Container>
    )
}